<template lang="pug">
.view-panel
  GenericCard.productList(size='85' ignoreMaxWidth)
    .sticky-top.bg-white
      .custom-header
        CustomTab.flex-fill(
          :tabItems='tabItems'
          :tabItemsOptions='tabItemsOptions'
          v-model='filterGrade'
        )
      .d-flex.align-items-end.px-4.py-4
        //- CustomerCompactDetailHeader(:data='customer')
        //- PanelTitleRight.ml-auto(
        //-   title='รายการ Back Order'
        //-   :subtitle='`${tableData.length} รายการ`'
        //-   v-model='filterDate'
        //- )
        CustomSearchBox.w-50(
          v-model='filterSearch'
          :isLoading='isLoading'
          type='text' placeholder='ค้นหาด้วยชื่อสินค้าหรือรหัสสินค้า'
          width='100%'
        )

        div.ml-auto.text-right
          .text-large
            | ราคาขายสินค้าและค่าคอมมิชชั่น
          .text-medium.mt-2
            | อัพเดทวันที่
            | {{ $moment().format('D MMMM YYYY') }}

      //- .d-flex.align-items-end.px-4.py-2
      //-   CustomCategoriesFilter(
      //-     title='เลือกดูรายการ'
      //-     :items='statusList'
      //-     v-model='filterStatus'
      //-   )

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.scrollable.h-scrollable
        CustomTable.w-max-content(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :selectable='false'
          :showNotificationDots='false'
          :itemClickable='false'
          v-model='selectedItemsIndexes'
          :startIndex='pageFirstRowIndex'
          @itemClicked='updateSelectedItems'
        )
      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )

</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

import BackOrderDetail from '@/components/history/dialogs/BackOrder/BackOrderDetail.vue';
import QuotationDetail from '@/components/history/dialogs/Quotation/QuotationDetail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    // reload data
    customer() { this.currentPage = 1; this.loadData(); },
    filterGrade() { this.currentPage = 1; this.loadData(); },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // && (!this.filterStatus || item.status.toString() === this.filterStatus)
      //     (!KEYWORD
      //       || item.name.toString().toUpperCase().includes(KEYWORD)
      //       || item.id.toString().toUpperCase().startsWith(KEYWORD)
      //     )
      //   );
      // });
      return this.tableData;
    },
    shouldButtonsBeDisabled() {
      return !this.selectedItemsIndexes || this.selectedItemsIndexes.length === 0;
    },
  },
  data() {
    return {
      isLoading: false,

      tabItems: {
        A: 'เกรด A',
        B: 'เกรด B',
        C: 'เกรด C',
        D: 'เกรด D',
      },
      tabItemsOptions: {},
      filterGrade: 'A',

      /* eslint-disable quote-props */
      // statusList: {
      //   0: 'รอสินค้า',
      //   1: 'พร้อม',
      //   2: 'ยกเลิก',
      // },
      // filterStatus: '',

      // filterDate: '',
      filterSearch: '',

      tableData: [],
      tableColumns: {
        productCode: {
          title: 'รหัสสินค้า',
          align: 'left',
          computed: row => row.id,
        },
        productName: {
          title: 'ชื่อสินค้า',
          align: 'left',
          computed: row => row.name,
        },
        unit: {
          title: 'หน่วย',
          align: 'center',
        },
        weight: {
          title: 'น้ำหนัก',
          align: 'center',
          type: Number,
        },
        productGroup: {
          title: 'กลุ่ม',
          align: 'center',
          computed: row => row.group_id,
        },
        // sellPriceLv1: {
        //   title: 'ราคาขายระดับ 1',
        //   align: 'right',
        //   type: Number,
        //   computed(row) {
        //     return row.price_levels[0].sellPriceMin;
        //   },
        // },

        // add sellPrices in mounted() instead, so we can use for loop
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItems: [],
      selectedItemsIndexes: [],
      // selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      // load data
      try {
        const res = await this.$api.product.listWithPrices(
          this.filterGrade,
          this.currentPage,
          this.filterSearch,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    updateSelectedItems(e) {
      // if (!this.selectedItems.includes(e))
      // this.selectedItem = e.data;
      // this.$modal.show('back-order');
      console.log(e);
    },
    showModal(modalName = 'back-order') {
      // create an array of selectedItems
      const selectedItems = [];
      for (let i = 0; i < this.selectedItemsIndexes.length; i += 1) {
        const INDEX = this.selectedItemsIndexes[i];
        selectedItems.push(this.tableData[INDEX]);
      }
      this.selectedItems = selectedItems;
      this.$modal.show(modalName);
    },
    hideModal(modalName = 'back-order') {
      this.$modal.hide(modalName);
    },
    cancelBackOrder() {
      this.hideModal();
      // this.$modal.show('dialog', {
      //   // title: 'ยกเลิกรายการเรียบร้อยแล้ว',
      //   text: 'ยกเลิกรายการเรียบร้อยแล้ว',
      //   buttons: [
      //     {
      //       title: 'ตกลง',
      //     },
      //   ],
      // });
      this.showStatusDialog();
    },
    makeASell() {
      this.hideModal();
      this.$router.push({
        name: 'sales.new-order', // can't use path, cause it WON'T allow passing hidden params
        params: {
          customerId: this.customer.id,
        },
      });
    },
    showStatusDialog() {
      this.$modal.show('action-status');
    },
    hideStatusDialog() {
      this.$modal.hide('action-status');
    },

  },
  mounted() {
    // add more tableColumns
    for (let i = 0; i < 7; i += 1) {
      const sellPrice = {
        title: `ราคาขายระดับ ${i + 1}`,
        align: 'center',
        // type: Number,
        computed: (row) => {
          const {
            price_min: priceMin,
            price_max: priceMax,
          } = row.price_levels[i];

          return `
            <div class='mx-2'>
              ${priceMin} - ${priceMax}
            </div>
          `;
        },
      };
      this.tableColumns[`sellPriceLv${i + 1}`] = sellPrice;
    }

    // load the data later
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,

    BackOrderDetail,
    QuotationDetail,
  },
};
</script>

<style lang="scss">
.view-panel {
  .panel-title {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 24px;
  }
  .panel-subtitle {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 17px;
  }
}
</style>
